
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/houses/show/[id]",
      function () {
        return require("private-next-pages/houses/show/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/houses/show/[id]"])
      });
    }
  